import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1179870__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Dokument", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1179870__cls-1{fill:none}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M125.23 68.77V22H64.72v51.02l39.86 39.86s.03.04.05.07q.225.24.42.51c.01.01.02.03.03.04.13.19.23.4.33.61l.06.15c.02.06.05.12.07.18l8.97 26.92c.48 1.44.1 3.02-.97 4.09-.76.76-1.78 1.17-2.83 1.17-.42 0-.85-.07-1.26-.21l-26.92-8.97-.15-.06a1 1 0 0 1-.17-.07c-.21-.09-.42-.19-.61-.32-.01 0-.02-.02-.03-.02-.19-.13-.37-.28-.54-.44-.02-.02-.04-.03-.06-.05l-16.26-16.26v49.77h111.28V72.77h-46.76c-2.21 0-4-1.79-4-4",
      class: "i-1179870__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "m170.33 64.77-37.1-37.11v37.11zM91.21 131.91l13.19 4.39-4.4-13.19z",
      class: "i-1179870__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M183.91 67.98a4.6 4.6 0 0 0-.2-.66c-.02-.06-.05-.12-.08-.18a4 4 0 0 0-.25-.47l-.11-.17c-.14-.19-.28-.38-.45-.55l-50.77-50.78c-.17-.17-.36-.32-.55-.45a1 1 0 0 0-.17-.1 4 4 0 0 0-.47-.25c-.06-.03-.12-.06-.18-.08a3.2 3.2 0 0 0-.67-.2c-.23-.05-.47-.06-.7-.07H60.72c-2.21 0-4 1.79-4 4v47.02L32.79 41.11a4.01 4.01 0 0 0-5.66 0L9.18 59.04a4.004 4.004 0 0 0 0 5.66l47.54 47.53V174c0 2.21 1.79 4 4 4H180c2.21 0 4-1.79 4-4V68.69c0-.24-.02-.47-.07-.7Zm-13.58-3.22h-37.11v-37.1l37.11 37.11Zm-65.94 71.54-13.19-4.4 8.79-8.79zM29.96 49.57l26.76 26.76 8 8L96.1 115.7l-12.29 12.29-19.08-19.08-8-8-39.06-39.05zM176 170H64.72v-49.77l16.26 16.26s.04.03.06.05c.17.16.35.31.54.44.01 0 .02.02.03.02.19.13.4.23.61.32.06.02.11.05.17.07l.15.06 26.92 8.97c.41.14.84.21 1.26.21a4 4 0 0 0 3.8-5.26l-8.97-26.92c-.02-.06-.05-.12-.07-.18l-.06-.15a3.6 3.6 0 0 0-.36-.65c-.12-.18-.27-.35-.42-.51-.02-.02-.03-.05-.05-.07L64.73 73.03V22h60.51v46.77c0 2.21 1.79 4 4 4H176z",
      style: {"fill":"#2d2d2d"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "documentEdit"}) } }